// Допустимая погрешность при детекте клика (px)
var POSSIBLE_INACCURACY = 3;
export function isClick(oldPoint, newPoint) {
  var oldX = oldPoint.x,
    oldY = oldPoint.y;
  var x = newPoint.x,
    y = newPoint.y;
  return Math.abs(x - oldX) <= POSSIBLE_INACCURACY && Math.abs(y - oldY) <= POSSIBLE_INACCURACY;
}